import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import classnames from 'classnames/bind'
import styles from '../styles.scss'
import ListingBadge, { BADGE_MODE } from './base'
import { isREO } from './utils'

const cx = classnames.bind(styles)

// TODO: Find way to generate this consistently from the badge name so we don't have all these things lying around.
const elmId = 'open_house_badge'

export default class OpenHouseScheduledBadge extends ListingBadge {
  static title = 'Open House'

  static titleIcon = 'sign-in-alt'

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    if (badgeMode === BADGE_MODE.CONDENSED) return false

    const openHouseSchedules = listing.open_houses || []

    // We don't check if there is a _valid_ date, only that a date exists. We can maybe look at changing this later on.
    return (
      Boolean(openHouseSchedules.length) &&
      openHouseSchedules[0].date &&
      isREO(listing)
    )
  }

  get content() {
    const openHouseSchedules = _.get(this.props.listing, 'open_houses', [])

    return (
      <div>
        Tour this property on:
        {openHouseSchedules.map((schedule, i) => (
          <span key={i} className={cx('u-display-f', 'u-display-f-between')}>
            <strong data-elm-id={`${elmId}_date_${i}`}>
              {moment(schedule.date, 'YYYY-MM-DD').format('MM/DD/YY')}
            </strong>{' '}
            <span data-elm-id={`${elmId}_time_${i}`}>
              {schedule.start_time} to {schedule.end_time}
            </span>
          </span>
        ))}
      </div>
    )
  }
}
